import { useMemo } from "react";
import { useTenant } from "./useTenant";
import { normalizePlanId, PLAN_IDS, resolvePlanFeatures } from "../constants/plans";

export const usePlan = () => {
    const { planId, featureOverrides, effectiveFeatures, loading } = useTenant();

    const resolvedPlanId = normalizePlanId(planId || PLAN_IDS.NEO);

    const features = useMemo(
        () => resolvePlanFeatures(resolvedPlanId, featureOverrides, effectiveFeatures),
        [resolvedPlanId, featureOverrides, effectiveFeatures]
    );

    const hasFeature = (featureKey) => features?.[featureKey] === true;

    return {
        planId: resolvedPlanId,
        features,
        hasFeature,
        loading,
    };
};
